import { render, staticRenderFns } from "./SelectTuevsComponent.vue?vue&type=template&id=cb2c1dfe&scoped=true&"
import script from "./SelectTuevsComponent.vue?vue&type=script&lang=js&"
export * from "./SelectTuevsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2c1dfe",
  null
  
)

export default component.exports